<template>
  <div class="toolbar-wrap" :class="{'mobile': mobile}">
    <div v-if="checkPermissions(['chat_public_chat_view']) || isBoothChat" @click="publicChat">
      <span :class="{'yellow': tab == 1}">{{ message }}</span>
      <img v-if="!mobile" :src="tab == 1 ? $images.publicIcon : $images.publicIconBlack" alt />
    </div>
    <div class="line"></div>
    <div v-if="checkPermissions(['chat_private_chat_view'])" @click="messaging">
      <span :class="{'yellow': tab == 2}">{{$t('chat.messaging')}}</span>
      <img v-if="!mobile" :src="tab == 2 ? $images.messageIcon : $images.messageIconBlack" alt />
    </div>
    <div class="line"></div>
    <div @click="onlineParticipants">
      <span v-if="mobile">{{$t('chat.online')}}</span>
      <span v-else>{{$t('chat.onlineParticipants')}}</span>
      <div v-if="!mobile" class="green-dot"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tab: Number,
		orientation: Boolean,
		mobile: Boolean,
    // Public chat is replaced with booth chat if the boolean is true
    isBoothChat: Boolean,
  },
  computed: {
    message () {
      return this.isBoothChat? this.$t('chat.boothChatLower') : this.$t('chat.publicChat');
    },
  },
  methods: {
    publicChat() {
      this.$emit("publicchat");
    },
    messaging() {
      this.$emit("messaging");
    },
    onlineParticipants() {
      this.$emit("onlineparticipants");
    }
  }
};
</script>

<style lang="scss" scoped>
@mixin flex-end {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
@mixin flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
@mixin flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

$toolbar-height: 40px;
$padding-width: 20px;

.toolbar-wrap {
  user-select: none;
  @include flex-center;
  height: $toolbar-height;
  width: 100%;
  position: absolute;
  bottom: 0;
  border-radius: 0 0 8px 8px;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.25);
  background-color: rgb(255, 255, 255);
  &.mobile {
    position: relative;
    width: calc(100% - 40px);
    margin: 0 auto;
    border-radius: 10px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
    background-color: rgb(255, 255, 255);
    .line {
      width: 2px;
      height: 60%;
    }
  }
  .line {
    width: 1px;
    height: 100%;
    background-color: #dddddd;
  }
  div {
    filter: hue-rotate(0deg);
    cursor: pointer;
    border-radius: 0 0 8px 8px;
    width: 100%;
    height: $toolbar-height;
    font-size: 14px;
    font-weight: 300;
    @include flex-center;
    .yellow {
      color: #f4aa33;
    }
    img {
      margin-left: 5px;
      width: 17px;
    }
    .green-dot {
      margin-left: 5px;
      width: 7px;
      height: 7px;
      border-radius: 50%;
      background-color: #69d200;
    }
  }
}
</style>